import { render } from "./QuranMetaCard.vue?vue&type=template&id=0612a145"
import script from "./QuranMetaCard.vue?vue&type=script&lang=js"
export * from "./QuranMetaCard.vue?vue&type=script&lang=js"
script.render = render

export default script